import { useGetApecCardReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function ApecCardReport() {
  const { t } = useTranslation();
  return (
    <PivotReportTemplate
      title={t('common:apec-card-report')}
      usePivotQuery={useGetApecCardReport}
      completeName={['customer', 'admin', 'guest', 'status']}
    />
  );
}
